import React, { Component } from 'react'

import './index.scss'

class Column extends Component {
    render() {
        return (
            <div className="Column">
                <div className="CBorder">
                    十年非凡成就，蕴藏深刻启示。如何用中国理论阐释中国实践？
                    新华网联合中央党校（国家行政学院）国家高端智库，推出“思客讲堂·党校公开课（第三季）”《以“理”服人：十年的十个“为什么”》。
                    十位党校青年教师通过十集理论短视频，带你探究非凡成就背后的“中国密码”。
                </div>
                <div className="al"></div>
                <div className="ar"></div>
            </div>
        )
    }
}

export default Column
